var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "27px",
    viewBox: "0 0 32 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "folder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mappenstructuur_open_actief",
    transform: "translate(-82.000000, -120.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.2.1",
    transform: "translate(0.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder",
    transform: "translate(82.000000, 6.000000)",
    fill: "#F7893C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.41315,0.65 C14.3166,0.65 15.05,1.3834 15.05,2.2878 L15.05,2.2878 L15.05,5.4 L29.56315,5.4 C30.4666,5.4 31.2,6.1334 31.2,7.0378 L31.2,7.0378 L31.2,24.6622 C31.2,25.5666 30.4666,26.3 29.56315,26.3 L29.56315,26.3 L2.4378,26.3 C1.5334,26.3 0.8,25.5666 0.8,24.6622 L0.8,24.6622 L0.8,7.0378 C0.8,6.1334 1.5334,5.4 2.4378,5.4 L2.4378,5.4 L4.86315,5.4 L4.86315,2.2878 C4.86315,1.3834 5.5956,0.65 6.5,0.65 L6.5,0.65 Z M28.35,8.25 L3.65,8.25 L3.65,23.45 L28.35,23.45 L28.35,8.25 Z M13.15095,2.55 L6.76315,2.55 L6.76315,5.4 L13.15095,5.4 L13.15095,2.55 Z",
    id: "Fill-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOrange);
export default __webpack_public_path__ + "static/media/folderOrange.14cf29419f14e13af8201a6880bcd4bb.svg";
export { ForwardRef as ReactComponent };